import PropTypes from 'prop-types';
import React, { Component } from 'react';
import en from '../../../../international/translations/en';
import config from '../../../../config';
import daysFromNowUntil from '../../../../utils/daysFromNowUntil';
import { parseBillingDate } from '../../../../utils/getPlanSubHeadingUtils';

export default class SubscriptionSummaryCard extends Component {
  static propTypes = {
    subscription: PropTypes.object.isRequired,
    companyMap: PropTypes.array.isRequired,
    overview: PropTypes.object,
    renewHandler: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.copy = en.account.overview.subs_card;
  }

  getExpiringMessage = (subscription, periodEnd, brand) => {
    if (subscription.type === 'apple') return en.subscription.subheading_apple;
    else if (subscription.type === 'google') return en.subscription.subheading_google;
    else if (subscription.type === 'vip') return '';
    else if (subscription.expiring) {
      return en.subscription.subheading_expiring(
        parseBillingDate(periodEnd),
        brand
      );
    }
  }

  calculateDaysUntilEndDate(date) {
    return daysFromNowUntil(date);
  }

  trackClick = (brand) => {
    window.analytics.track(
      'Clicked Subscribe CTA',
      {
        ctaLocation: 'account-overview summary card',
        brandSelected: brand
      }
    );
  }

  render() {
    const { subscription, companyMap } = this.props;
    const brandName = { sl: 'Surfline', bw: 'Buoyweather', fs: 'FishTrack' };

    return (
      <div className="subscription__card">
        {
          companyMap.map((brand, index) => {
            const sub = subscription.subscriptions[brand][0];
            return (
              <div key={index} className="subscription__card__inner">
                {

                  sub && (sub.entitlement === `${brand}_premium` || sub.entitlement === `${brand}_vip`) ?
                    <div className="subscription__card__message">
                      <div className="subscription__card__message__left">
                        <h5 className="subscription__card__message__left__title">{brandName[brand]}</h5>
                        <p className="subscription__card__message__left__entitlement">
                          {this.copy[sub.type]}
                        </p>
                      </div>
                      <div className="subscription__card__message__right">
                        {
                          sub && (sub.expiring || sub.entitlement === `${brand}_vip`) ?
                            <p className="subscription__card__message__right__message" >
                              {
                                this.getExpiringMessage(
                                  sub,
                                  sub.periodEnd,
                                  brandName[brand]
                                )}
                            </p>
                            :
                            <p className="subscription__card__message__right__message">
                              {this.copy.message(this.calculateDaysUntilEndDate(sub.periodEnd), sub.onTrial)}
                            </p>
                        }
                      </div>
                    </div>
                    :
                    <div className="subscription__card__message">
                      <div className="subscription__card__message__left">
                        <h5 className="subscription__card__message__left__title">
                          {brandName[brand]}
                        </h5>
                      </div>
                      <div className="subscription__card__message__right">
                        <i className="subscription__card__message__right__icon fa fa-plus" aria-hidden="true" />
                        <a
                          onClick={() => this.trackClick(brand)}
                          className="subscription__card__message__right__link"
                          href={`${config.accountLinkProtocol}${brandName[brand]}.com${config.selectPlanRedirect}`}
                          target="_blank"
                        >
                          {this.copy.add_premium}
                        </a>
                      </div>
                    </div>
                }
              </div>
            );
          })
        }
      </div>
    );
  }
}
